<template>
<div>

  <v-data-table
    :headers="headers"
    :items="items"
    item-key="lea_coordid"
    dense
    @click:row="focusItem"
  >

    <template  v-slot:item.risq_score="{ item }">
         <div :style="`font-weight: bold; `.concat(style(item, 'risq_score'))" v-text="item.risq_score"/>
    </template>


    <template v-slot:item.hurricane_score="{ item }">
      <div :style="style(item, 'hurricane_score')" v-text="item.hurricane_score" />
    </template>

    <template v-slot:item.flood_score="{ item }">
      <div :style="style(item, 'flood_score')"  v-text="item.flood_score" />
    </template>

    <template v-slot:item.wildfire_score="{ item }">
      <div :style="style(item, 'wildfire_score')"  v-text="item.wildfire_score" />
    </template>

    <template v-slot:item.social_impact_score="{ item }">
      <div style="font-weight:bold;" v-text="item.social_impact_score" />
    </template>


  </v-data-table>

</div>
</template>
<script>
import {highlight} from '@/utils/utils'
import { mapState } from 'vuex'
import { risQScores } from '../utils/risq_score.js'

  export default {
  data: () => ({
    newCusip: null,
    headerCols: ['risq_score','hurricane_score','flood_score','wildfire_score','social_impact_score','low_affluence_score','low_education_score','low_prestige_employment_score','health_obstacle_score','poverty_concentration_score','pct_income_on_housing_score','minority_score'],
    headers: [{text: 'Name', value: 'name', divider: true}]
  }),
  props: {
    items: Array
  },
  computed: {
    ...mapState({
      cusip: 'currentCusip',
      loading: 'loading',
      user: 'user',
      labels: 'labels'
    }),
    orangePoint(){
        return risQScores.orangePoint
    },
    userCanSeeRandomButton: function() {
      /* yes, it's not ideal to hard code Alexa's user ID here */
      return this.user && (this.user.account && this.user.account.id === 1 || this.user.user_id == 248)
    }
  },
  methods: {
    highlight(params){
       

        return highlight(...params)
    },
    style(item, category){
        return item[category] > this.orangePoint? this.highlight([this.getColor(item[category]), '160%', '10%', '90%', undefined, '80%']).concat('margin-left: -30%;'): ''
    },
    focusItem(item) {
      this.$store.dispatch('selectPropertyById', item.id)
    },
    getColor(val) {
      return risQScores.getTextColor(val)
    },
    showDivider(colName) {
      return colName == 'wildfire_score'
    },
    getItemClass(item) {
      return item
    },
    getRandomCusip() {
      this.$store.dispatch('getCusipData', `random?st=${this.securityType}`)
      this.$router.push({name: 'Securities'})
    },
  },
  mounted() {
    this.headerCols.forEach(header => {
      this.headers.push({text: this.labels[header], value: header, align: 'center', divider: this.showDivider(header)})
    })
  }
}
</script>
<style scoped>
table th + th { border-left:1px solid #dddddd; }

.v-text-field--outlined >>> fieldset {
  border-color: rgba(192, 0, 250, 0.986) !important;
}

</style>
